var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-vertical-demo",
      staticStyle: { width: "200px" },
      attrs: {
        "background-color": "#545c64",
        "text-color": "#fff",
        "active-text-color": "#ffd04b",
        router: ""
      },
      on: { open: _vm.handleOpen, close: _vm.handleClose }
    },
    [_c("left_menu", { attrs: { menus: _vm.menus } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a8d54a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8d54a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/left_menu_pure.vue
// module id = null
// module chunks = 